import { useEffect, useState } from "react";
import { notificationTests } from "src/api/config/notifications.config";
import { getItemsRequest } from "src/modules/spItems/api";

export const useGetQuestionsCount = (testID: number) => {
  const [testData, setTestData] = useState(0);

  async function getItemsRequestAsync() {
    if (testID) {
      try {
        const test = await getItemsRequest({
          listName: notificationTests,
          filters: { ID: testID },
        });
        setTestData(test?.items?.[0]?.Questions.length);
      } catch (error) {
        console.error("Error fetching items:", error);
      }
    }
  }

  useEffect(() => {
    getItemsRequestAsync();
  }, [testID]);

  return testData;
};
